import { render } from "./statistic-page.vue?vue&type=template&id=32524c5f"
import script from "./statistic-page.vue?vue&type=script&lang=js"
export * from "./statistic-page.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__